/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_Wrapped_MetaInputs */

const en_us2_search_action_wrapped_meta = /** @type {(inputs: Search_Action_Wrapped_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your weeks in numbers`)
};

const pt_br2_search_action_wrapped_meta = /** @type {(inputs: Search_Action_Wrapped_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas semanas em números`)
};

const es_419_search_action_wrapped_meta = /** @type {(inputs: Search_Action_Wrapped_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus semanas en números`)
};

const pt_pt2_search_action_wrapped_meta = /** @type {(inputs: Search_Action_Wrapped_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tuas semanas em números`)
};

const fr_fr2_search_action_wrapped_meta = /** @type {(inputs: Search_Action_Wrapped_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes semaines en chiffres`)
};

const de_de2_search_action_wrapped_meta = /** @type {(inputs: Search_Action_Wrapped_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Wochen in Zahlen`)
};

const it_it2_search_action_wrapped_meta = /** @type {(inputs: Search_Action_Wrapped_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue settimane in numeri`)
};

/**
* | output |
* | --- |
* | "Your weeks in numbers" |
*
* @param {Search_Action_Wrapped_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_wrapped_meta = /** @type {((inputs?: Search_Action_Wrapped_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_Wrapped_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_wrapped_meta(inputs)
	if (locale === "es-419") return es_419_search_action_wrapped_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_wrapped_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_wrapped_meta(inputs)
	if (locale === "de-DE") return de_de2_search_action_wrapped_meta(inputs)
	if (locale === "it-IT") return it_it2_search_action_wrapped_meta(inputs)
	return en_us2_search_action_wrapped_meta(inputs)
});
export { search_action_wrapped_meta as "search.action_wrapped_meta" }